import union from 'lodash/fp/union';

const rawLocations = {
  countries: [
    'Afghanistan',
    'Aland Islands',
    'Albania',
    'Algeria',
    'American Samoa',
    'Andaman & Nicobar Islands',
    'Andorra',
    'Angola',
    'Anguilla',
    'Antarctica',
    'Antigua and Barbuda',
    'Argentina',
    'Armed Forces America',
    'Armed Forces Europe',
    'Armed Forces Pacific',
    'Armenia',
    'Aruba',
    'Ascension Island',
    'Australia',
    'Austria',
    'Azerbaijan',
    'Bahamas',
    'Bahrain',
    'Bangladesh',
    'Barbados',
    'Belgium',
    'Belize',
    'Benin',
    'Bermuda',
    'Bhutan',
    'Bolivia, Plurinational State of',
    'Bonaire, Sint Eustatius and Saba',
    'Bosnia and Herzegovina',
    'Botswana',
    'Bouvet Island',
    'Brazil',
    'British Indian Ocean Territory',
    'Brunei Darussalam',
    'Bulgaria',
    'Burkina Faso',
    'Burundi',
    'Cambodia',
    'Cameroon',
    'Canada',
    'Cape Verde',
    'Cayman Islands',
    'Central African Republic',
    'Chad',
    'Chile',
    'China',
    'Christmas Island',
    'Cocos (Keeling) Islands',
    'Colombia',
    'Comoros',
    'Congo',
    'Congo, the Democratic Republic of the',
    'Cook Islands',
    'Costa Rica',
    "Cote d'Ivoire",
    'Croatia',
    'Cuba',
    'Curaçao',
    'Cyprus',
    'Czech Republic',
    'Dadra and Nagar Haveli',
    'Daman and Diu',
    'Denmark',
    'Diego Garcia',
    'Djibouti',
    'Dominica',
    'Dominican Republic',
    'Ecuador',
    'Egypt',
    'El Salvador',
    'Equatorial Guinea',
    'Eritrea',
    'Estonia',
    'Ethiopia',
    'Falkland Islands (Malvinas)',
    'Faroe Islands',
    'Federated States Of Micronesia',
    'Fiji',
    'Finland',
    'France',
    'French Antilles',
    'French Guiana',
    'French Polynesia',
    'French Southern Territories',
    'Gabon',
    'Gambia',
    'Georgia',
    'Germany',
    'Ghana',
    'Gibraltar',
    'Greece',
    'Greenland',
    'Grenada',
    'Guadeloupe',
    'Guam',
    'Guangxi',
    'Guantanamo Bay',
    'Guatemala',
    'Guernsey',
    'Guinea',
    'Guinea-Bissau',
    'Guyana',
    'Haiti',
    'Heard Island and McDonald Islands',
    'Holy See (Vatican City State)',
    'Honduras',
    'Hong Kong',
    'Hungary',
    'IVORY COAST',
    'Iceland',
    'India',
    'Indonesia',
    'Iraq',
    'Ireland',
    'Isle of Man',
    'Israel',
    'Italy',
    'Jamaica',
    'Jammu & Kashmir',
    'Japan',
    'Jersey',
    'Jordan',
    'Kazakhstan',
    'Kenya',
    'Kiribati',
    'Korea, Republic of',
    'Kuwait',
    'Kyrgyz Republic',
    'Kyrgyzstan',
    "Lao People's Democratic Republic",
    'Latvia',
    'Lebanon',
    'Lesotho',
    'Liberia',
    'Libya',
    'Liechtenstein',
    'Lithuania',
    'Luxembourg',
    'Macao',
    'Macedonia, the former Yugoslav Republic of',
    'Madagascar',
    'Malawi',
    'Malaysia',
    'Maldives',
    'Mali',
    'Malta',
    'Marshall Islands',
    'Martinique',
    'Mauritania',
    'Mauritius',
    'Mayotte',
    'Mexico',
    'Moldova, Republic of',
    'Monaco',
    'Mongolia',
    'Montenegro',
    'Montserrat',
    'Morocco',
    'Mozambique',
    'Namibia',
    'Nauru',
    'Nei Mongol',
    'Nepal',
    'Neth Antilles',
    'Netherlands',
    'New Caledonia',
    'New Zealand',
    'Newfoundland and Labrador',
    'Nicaragua',
    'Niger',
    'Ningxia',
    'Niue',
    'Norfolk Island',
    'Northern Mariana Islands',
    'Norway',
    'Oman',
    'Pakistan',
    'Palau',
    'Palestine',
    'Panama',
    'Papua New Guinea',
    'Paraguay',
    'Peru',
    'Philippines',
    'Pitcairn',
    'Poland',
    'Portugal',
    'Puerto Rico',
    'Qatar',
    'Reunion',
    'Romania',
    'Rota Island',
    'Rwanda',
    'Saint Barthélemy',
    'Saint Helena, Ascension and Tristan da Cunha',
    'Saint Kitts and Nevis',
    'Saint Lucia',
    'Saint Martin (French part)',
    'Saint Pierre and Miquelon',
    'Saint Vincent and the Grenadines',
    'Saipan Island',
    'Sakha',
    'Samoa',
    'San Marino',
    'Sao Tome and Principe',
    'Saudi Arabia',
    'Senegal',
    'Serbia',
    'Seychelles',
    'Sierra Leone',
    'Singapore',
    'Sint Maarten (Dutch part)',
    'Slovakia',
    'Slovenia',
    'Solomon Islands',
    'Somalia',
    'South Africa',
    'South Georgia and the South Sandwich Islands',
    'South Sudan',
    'Spain',
    'Sri Lanka',
    'Sudan',
    'Suriname',
    'Svalbard and Jan Mayen',
    'Swaziland',
    'Sweden',
    'Switzerland',
    'Syrian Arab Republic',
    'Taiwan',
    'Tajikistan',
    'Tanzania, United Republic of',
    'Thailand',
    'Tibet',
    'Timor-Leste',
    'Tinian Island',
    'Togo',
    'Tokelau',
    'Tonga',
    'Trinidad and Tobago',
    'Tunisia',
    'Turkey',
    'Turkmenistan',
    'Turks and Caicos Islands',
    'Tuvalu',
    'Uganda',
    'Ukraine',
    'United Arab Emirates',
    'United Kingdom',
    'United States',
    'United States Minor Outlying Islands',
    'Uruguay',
    'Uzbekistan',
    'Vanuatu',
    'Venezuela, Bolivarian Republic of',
    'Viet Nam',
    'Virgin Islands (Us)',
    'Virgin Islands, British',
    'Wallis and Futuna',
    'Western Sahara',
    'Xinjiang',
    'Yemen',
    'Yugoslavia',
    'Yukon',
    'Zambia'
  ],
  algeriaStates: ['Oran'],
  angolaStates: ['Luanda', 'Malange'],
  argentinaStates: [
    'Salta',
    'Buenos Aires',
    'Ciudad Autónoma de Buenos Aires',
    'San Luis',
    'Entre Ríos',
    'La Rioja',
    'Santiago del Estero',
    'Chaco',
    'San Juan',
    'Catamarca',
    'La Pampa',
    'Mendoza',
    'Misiones',
    'Formosa',
    'Neuquén',
    'Río Negro',
    'Santa Fe',
    'Tucumán',
    'Chubut',
    'Tierra del Fuego',
    'Corrientes',
    'Córdoba',
    'Jujuy',
    'Santa Cruz'
  ],
  armeniaStates: ['Yerevan', 'Kotayk'],
  australiaStates: [
    'Australian Capital Territory',
    'New South Wales',
    'Northern Territory',
    'Queensland',
    'South Australia',
    'Tasmania',
    'Victoria',
    'Western Australia'
  ],
  austriaStates: [
    'Burgenland',
    'Carinthia',
    'Lower Austria',
    'Upper Austria',
    'Salzburg',
    'Styria',
    'Tyrol',
    'Vorarlberg',
    'Vienna'
  ],
  belgiumStates: [
    'Brussels-Capital Region',
    'Antwerp',
    'Flemish Brabant',
    'Flanders',
    'Limburg',
    'East Flanders',
    'West Flanders',
    'Wallonia',
    'Walloon Brabant',
    'Hainaut',
    'Liège',
    'Luxembourg',
    'Namur'
  ],
  botswanaStates: ['Gaborone', 'South East'],
  brazilStates: [
    'Acre',
    'Alagoas',
    'Amazonas',
    'Amapá',
    'Bahia',
    'Ceará',
    'Distrito Federal',
    'Espírito Santo',
    'Goiás',
    'Maranhão',
    'Minas Gerais',
    'Mato Grosso do Sul',
    'Mato Grosso',
    'Pará',
    'Paraíba',
    'Pernambuco',
    'Piauí',
    'Paraná',
    'Rio de Janeiro',
    'Rio Grande do Norte',
    'Rondônia',
    'Roraima',
    'Rio Grande do Sul',
    'Santa Catarina',
    'Sergipe',
    'São Paulo',
    'Tocantins'
  ],
  bulgariaStates: ['Burgas', 'Sofia'],
  cambodiaStates: ['Phnom Penh'],
  cameroonStates: [
    'Adamawa',
    'Centre',
    'Far North',
    'East',
    'Littoral',
    'North',
    'Northwest',
    'West',
    'South',
    'Southwest'
  ],
  canadaStates: [
    'Alberta',
    'British Columbia',
    'Manitoba',
    'New Brunswick',
    'Newfoundland and Labrador',
    'Nova Scotia',
    'Northwest Territories',
    'Nunavut',
    'Ontario',
    'Prince Edward Island',
    'Quebec',
    'Saskatchewan',
    'Yukon Territories'
  ],
  caymanislandsStates: ['george town'],
  chileStates: [
    'Aisén del General Carlos Ibañez del Campo',
    'Antofagasta',
    'Arica y Parinacota',
    'La Araucanía',
    'Atacama',
    'Biobío',
    'Coquimbo',
    "Libertador General Bernardo O'Higgins",
    'Los Lagos',
    'Los Ríos',
    'Magallanes y de la Antártica Chilena',
    'Maule',
    'Ñuble',
    'Región Metropolitana de Santiago',
    'Tarapacá',
    'Valparaíso'
  ],
  chinaStates: [
    'Beijing',
    'Tianjin',
    'Hebei',
    'Shanxi',
    'Nei Mongol',
    'Liaoning',
    'Jilin',
    'Heilongjiang',
    'Shanghai',
    'Jiangsu',
    'Zhejiang',
    'Anhui',
    'Fujian',
    'Jiangxi',
    'Shandong',
    'Henan',
    'Hubei',
    'Hunan',
    'Guangdong',
    'Guangxi',
    'Hainan',
    'Chongqing',
    'Sichuan',
    'Guizhou',
    'Yunnan',
    'Xizang',
    'Shaanxi',
    'Gansu',
    'Qinghai',
    'Ningxia',
    'Xinjiang',
    'Taiwan',
    'Hong Kong',
    'Macao'
  ],
  colombiaStates: [
    'Atlántico',
    'Amazonas',
    'Antioquia',
    'Arauca',
    'Bolívar',
    'Boyacá',
    'Caldas',
    'Caquetá',
    'Casanare',
    'Cauca',
    'Cesar',
    'Chocó',
    'Córdoba',
    'Cundinamarca',
    'Bogotá D.C.',
    'Guainía',
    'Guaviare',
    'Huila',
    'La Guajira',
    'Magdalena',
    'Meta',
    'Nariño',
    'Norte de Santander',
    'Putumayo',
    'Quindío',
    'Risaralda',
    'Santander',
    'Archipiélago de San Andrés, Providencia y Santa Catalina',
    'Sucre',
    'Tolima',
    'Valle del Cauca',
    'Vaupés',
    'Vichada'
  ],
  congothedemocraticrepublicoftheStates: [
    'Kongo Central',
    'Bas-Uélé',
    'Équateur',
    'Haut-Katanga',
    'Haut-Lomami',
    'Haut-Uélé',
    'Ituri',
    'Kasaï Central',
    'Kasaï Oriental',
    'Kwango',
    'Kwilu',
    'Kinshasa',
    'Kasaï',
    'Lomami',
    'Lualaba',
    'Maniema',
    'Mai-Ndombe',
    'Mongala',
    'Nord-Kivu',
    'Nord-Ubangi',
    'Sankuru',
    'Sud-Kivu',
    'Sud-Ubangi',
    'Tanganyika',
    'Tshopo',
    'Tshuapa'
  ],
  costaricaStates: ['Alajuela', 'San Jose'],
  cyprusStates: [
    'Nicosia District (Lefkoşa)',
    'Limassol District (Leymasun)',
    'Larnaca District (Larnaka)',
    'Famagusta District (Mağusa)',
    'Paphos District (Pafos)',
    'Kyrenia District (Keryneia)'
  ],
  czechrepublicStates: [
    'Praha-západ',
    'Svitavy',
    'Blansko',
    'Břeclav',
    'Kolín',
    'Královéhradecký kraj',
    'Liberecký kraj',
    'Moravskoslezský kraj',
    'Most',
    'Olomoucký kraj',
    'Přerov',
    'Příbram',
    'Rakovník',
    'Rychnov nad Kněžnou',
    'Jindřichův Hradec',
    'Cheb',
    'Chomutov',
    'Karlovy Vary',
    'Plzeň-město',
    'Praha-východ',
    'Šumperk',
    'Teplice',
    'Praha, Hlavní město',
    'Havlíčkův Brod',
    'Kraj Vysočina',
    'Plzeňský kraj',
    'Plzeň-sever',
    'Prachatice',
    'Semily',
    'Třebíč',
    'Karviná',
    'Chrudim',
    'Kladno',
    'Středočeský kraj',
    'Ústí nad Orlicí',
    'Frýdek-Místek',
    'Děčín',
    'Mělník',
    'Mladá Boleslav',
    'Nový Jičín',
    'Trutnov',
    'Vsetín',
    'Louny',
    'Český Krumlov',
    'Jičín',
    'Litoměřice',
    'Strakonice',
    'Kutná Hora',
    'Jeseník',
    'Jihočeský kraj',
    'Nymburk',
    'Sokolov',
    'Ústecký kraj',
    'Písek',
    'Domažlice',
    'Pelhřimov',
    'Tachov',
    'Vyškov',
    'Kroměříž',
    'Hradec Králové',
    'Jihomoravský kraj',
    'Plzeň-jih',
    'Uherské Hradiště',
    'Zlínský kraj',
    'Karlovarský kraj',
    'Brno-město',
    'Bruntál',
    'Česká Lípa',
    'Brno-venkov',
    'Jablonec nad Nisou',
    'Zlín',
    'Ostrava-město',
    'Jihlava',
    'Opava',
    'Rokycany',
    'Prostějov',
    'Tábor',
    'Liberec',
    'Ústí nad Labem',
    'Žďár nad Sázavou',
    'Znojmo',
    'Náchod',
    'České Budějovice',
    'Hodonín',
    'Klatovy',
    'Olomouc',
    'Pardubice',
    'Pardubický kraj'
  ],
  dominicanrepublicStates: [
    'Distrito Nacional',
    'Independencia',
    'La Altagracia Province',
    'La Romana Province',
    'La Vega Province',
    'María Trinidad Sánchez Province',
    'Monte Cristi Province',
    'Pedernales Province',
    'Peravia Province',
    'Puerto Plata Province',
    'Hermanas Mirabal Province',
    'Azua Province',
    'Samaná Province',
    'San Cristóbal Province',
    'San Juan Province',
    'San Pedro de Macorís',
    'Sánchez Ramírez Province',
    'Santiago Province',
    'Santiago Rodríguez Province',
    'Valverde Province',
    'Monseñor Nouel Province',
    'Monte Plata Province`',
    'Baoruco Province',
    'Hato Mayor Province',
    'San José de Ocoa Province',
    'Barahona Province',
    'Dajabón Province',
    'Duarte Province',
    'El Seibo Province',
    'Espaillat Province'
  ],
  ecuadorStates: [
    'Azuay',
    'Bolívar',
    'Carchi',
    'Orellana',
    'Esmeraldas',
    'Cañar',
    'Guayas',
    'Chimborazo',
    'Imbabura',
    'Loja',
    'Manabí',
    'Napo',
    'El Oro',
    'Pichincha',
    'Los Ríos',
    'Morona-Santiago',
    'Santo Domingo de los Tsáchilas',
    'Santa Elena',
    'Tungurahua',
    'Sucumbíos',
    'Cotopaxi',
    'Pastaza',
    'Zamora Chinchipe'
  ],
  egyptStates: ['Cairo', 'Ad Daqahliyah', 'Giza'],
  finlandStates: [
    'Åland Islands',
    'Pirkanmaa',
    'Ostrobothnia',
    'North Karelia',
    'Northern Ostrobothnia',
    'Northern Savonia',
    'Päijänne Tavastia',
    'Satakunta',
    'Uusimaa',
    'Finland Proper',
    'South Karelia',
    'Southern Savonia',
    'Kainuu',
    'Tavastia Proper',
    'Central Finland',
    'Kymenlaakso',
    'Baranya County',
    'Békés County',
    'Bács-Kiskun County',
    'Budapest',
    'Borsod-Abaúj-Zemplén County',
    'Csongrád County',
    'Debrecen',
    'Eger',
    'Érd',
    'Fejér County',
    'Győr-Moson-Sopron County',
    'Győr',
    'Hajdú-Bihar County',
    'Hódmezővásárhely',
    'Eastern Finland Province',
    'Jász-Nagykun-Szolnok County',
    'Kecskemét',
    'Kaposvár',
    'Lapland',
    'Miskolc',
    'Nagykanizsa',
    'Nógrád County',
    'Oulu Province'
  ],
  franceStates: [
    'Ain',
    'Aube',
    'Aude',
    'Aveyron',
    'Bouches-du-Rhône',
    'Calvados',
    'Cantal',
    'Charente',
    'Charente-Maritime',
    'Cher',
    'Corrèze',
    'Aisne',
    'Corse',
    "Côte-d'Or",
    "Côtes-d'Armor",
    'Creuse',
    'Dordogne',
    'Doubs',
    'Drôme',
    'Eure',
    'Eure-et-Loir',
    'Finistère',
    'Corse-du-Sud',
    'Haute-Corse',
    'Allier',
    'Gard',
    'Haute-Garonne',
    'Gers',
    'Gironde',
    'Hérault',
    'Ille-et-Vilaine',
    'Indre',
    'Indre-et-Loire',
    'Isère',
    'Jura',
    'Alpes-de-Haute-Provence',
    'Landes',
    'Loir-et-Cher',
    'Loire',
    'Haute-Loire',
    'Loire-Atlantique',
    'Loiret',
    'Lot',
    'Lot-et-Garonne',
    'Lozère',
    'Maine-et-Loire',
    'Hautes-Alpes',
    'Manche',
    'Marne',
    'Haute-Marne',
    'Mayenne',
    'Meurthe-et-Moselle',
    'Meuse',
    'Morbihan',
    'Moselle',
    'Nièvre',
    'Nord',
    'Alpes-Maritimes',
    'Oise',
    'Orne',
    'Pas-de-Calais',
    'Puy-de-Dôme',
    'Pyrénées-Atlantiques',
    'Hautes-Pyrénées',
    'Pyrénées-Orientales',
    'Bas-Rhin',
    'Haut-Rhin',
    'Rhône',
    'Métropole de Lyon',
    'Alsace',
    'Ardèche',
    'Haute-Saône',
    'Saône-et-Loire',
    'Sarthe',
    'Savoie',
    'Haute-Savoie',
    'Paris',
    'Seine-Maritime',
    'Seine-et-Marne',
    'Yvelines',
    'Deux-Sèvres',
    'Ardennes',
    'Somme',
    'Tarn',
    'Tarn-et-Garonne',
    'Var',
    'Vaucluse',
    'Vendée',
    'Vienne',
    'Haute-Vienne',
    'Vosges',
    'Yonne',
    'Ariège',
    'Territoire de Belfort',
    'Essonne',
    'Hauts-de-Seine',
    'Seine-Saint-Denis',
    'Val-de-Marne',
    "Val-d'Oise",
    'Guadeloupe',
    'Martinique',
    'French Guiana',
    'La Réunion',
    'Mayotte',
    'Auvergne-Rhône-Alpes',
    'Bourgogne-Franche-Comté',
    'Saint-Barthélemy',
    'Bretagne',
    'Clipperton',
    'Centre-Val de Loire',
    'Grand-Est',
    'Hauts-de-France',
    'Île-de-France',
    'Saint-Martin',
    'Nouvelle-Aquitaine',
    'Normandie',
    'Occitanie',
    'Provence-Alpes-Côte-d’Azur',
    'Pays-de-la-Loire',
    'French Polynesia',
    'Saint Pierre and Miquelon',
    'French Southern and Antarctic Lands',
    'Wallis and Futuna'
  ],
  germanyStates: [
    'Brandenburg',
    'Berlin',
    'Baden-Württemberg',
    'Bavaria',
    'Bremen',
    'Hesse',
    'Hamburg',
    'Mecklenburg-Vorpommern',
    'Lower Saxony',
    'North Rhine-Westphalia',
    'Rhineland-Palatinate',
    'Schleswig-Holstein',
    'Saarland',
    'Saxony',
    'Saxony-Anhalt',
    'Thuringia'
  ],
  greeceStates: [
    'Aetolia-Acarnania Regional Unit',
    'Argolis Regional Unit',
    'Arcadia Prefecture',
    'Achaea Regional Unit',
    'Corinthia Regional Unit',
    'Laconia',
    'Corfu Prefecture',
    'Kefalonia Prefecture',
    'Lefkada Regional Unit',
    'Boeotia Regional Unit',
    'Ioannina Regional Unit',
    'Preveza Prefecture',
    'Euboea',
    'Karditsa Regional Unit',
    'Larissa Prefecture',
    'Grevena Prefecture',
    'Drama Regional Unit',
    'Imathia Regional Unit',
    'Thessaloniki Regional Unit',
    'Kastoria Regional Unit',
    'Kilkis Regional Unit',
    'Kozani Prefecture',
    'Pella Regional Unit',
    'Phthiotis Prefecture',
    'Serres Prefecture',
    'Chania Regional Unit',
    'East Macedonia and Thrace',
    'East Attica Regional Unit',
    'Central Macedonia',
    'West Macedonia Region',
    'Epirus Region',
    'Ionian Islands Region',
    'West Greece Region',
    'Central Greece Region',
    'Attica Region',
    'Peloponnese Region',
    'South Aegean',
    'Crete Region'
  ],
  hongkongStates: [
    'Central and Western District',
    'Eastern',
    'Southern',
    'Wan Chai',
    'Kowloon City',
    'Kwun Tong',
    'Sham Shui Po',
    'Wong Tai Sin',
    'Yau Tsim Mong',
    'Islands District',
    'Kwai Tsing',
    'North',
    'Sai Kung District',
    'Sha Tin',
    'Tuen Mun',
    'Tai Po District',
    'Tsuen Wan District',
    'Yuen Long District'
  ],
  hungaryStates: [
    'Baranya County',
    'Békés County',
    'Bács-Kiskun County',
    'Budapest',
    'Borsod-Abaúj-Zemplén County',
    'Csongrád County',
    'Debrecen',
    'Dunaújváros',
    'Eger',
    'Érd',
    'Győr-Moson-Sopron County',
    'Győr',
    'Hajdú-Bihar County',
    'Heves County',
    'Hódmezővásárhely',
    'Jász-Nagykun-Szolnok County',
    'Kecskemét',
    'Kaposvár',
    'Miskolc',
    'Nagykanizsa',
    'Nograd County',
    'Nyíregyháza',
    'Pest County',
    'Pécs',
    'Szeged',
    'Székesfehérvár',
    'Szombathely',
    'Szolnok',
    'Sopron',
    'Somogy County',
    'Szekszárd',
    'Salgótarján',
    'Tatabánya',
    'Tolna County',
    'Vas County',
    'Veszprém County',
    'Veszprém',
    'Zala County',
    'Zalaegerszeg'
  ],
  indiaStates: [
    'Telangana',
    'Andaman and Nicobar Islands',
    'Andhra Pradesh',
    'Arunachal Pradesh',
    'Assam',
    'Bihar',
    'Chandigarh',
    'Chhattisgarh',
    'Daman and Diu',
    'Delhi',
    'Dadra and Nagar Haveli',
    'Goa',
    'Gujarat',
    'Himachal Pradesh',
    'Haryana',
    'Jharkhand',
    'Jammu and Kashmir',
    'Karnataka',
    'Kerala',
    'Lakshadweep',
    'Maharashtra',
    'Meghalaya',
    'Manipur',
    'Madhya Pradesh',
    'Mizoram',
    'Nagaland',
    'Odisha',
    'Punjab',
    'Puducherry',
    'Rajasthan',
    'Sikkim',
    'Tamil Nadu',
    'Tripura',
    'Uttar Pradesh',
    'Uttarakhand',
    'West Bengal'
  ],
  indonesiaStates: [
    'Aceh',
    'Bali',
    'Kepulauan Bangka Belitung',
    'Bengkulu',
    'Banten',
    'Gorontalo',
    'Jambi',
    'Jawa Barat',
    'Jawa Timur',
    'DKI Jakarta',
    'Jawa Tengah',
    'Kalimantan Barat',
    'Kalimantan Timur',
    'Kepulauan Riau',
    'Kalimantan Selatan',
    'Kalimantan Tengah',
    'Kalimantan Utara',
    'Lampung',
    'Maluku',
    'Maluku Utara',
    'Nusa Tenggara Barat',
    'Nusa Tenggara Timur',
    'Papua',
    'Papua Barat',
    'Riau',
    'Sulawesi Utara',
    'Sumatera Barat',
    'Sulawesi Tenggara',
    'Sulawesi Selatan',
    'Sulawesi Barat',
    'Sumatera Selatan',
    'Sulawesi Tengah',
    'Sumatera Utara',
    'DI Yogyakarta'
  ],
  irelandStates: [
    'Clare',
    'Cavan',
    'Cork',
    'Carlow',
    'Dublin',
    'Donegal',
    'Galway',
    'Kildare',
    'Kilkenny',
    'Kerry',
    'Leinster',
    'Longford',
    'Louth',
    'Limerick',
    'Leitrim',
    'Laois',
    'Meath',
    'Monaghan',
    'Mayo',
    'Offaly',
    'Roscommon',
    'Sligo',
    'Tipperary',
    'Waterford',
    'Westmeath',
    'Wicklow',
    'Wexford'
  ],
  israelStates: [
    'Southern District',
    'Haifa District',
    'Jerusalem District',
    'Central District',
    'Tel Aviv District',
    'Northern District'
  ],
  italyStates: [
    'Lombardy',
    'Piedmont',
    'Sicily',
    'Agrigento',
    'Alessandria',
    'Ancona',
    'Aosta',
    'Ascoli Piceno',
    "L'Aquila",
    'Arezzo',
    'Asti',
    'Avellino',
    'Bari',
    'Bergamo',
    'Biella',
    'Belluno',
    'Benevento',
    'Bologna',
    'Brindisi',
    'Brescia',
    'Barletta-Andria-Trani',
    'Bolzano',
    'Cagliari',
    'Campobasso',
    'Caserta',
    'Chieti',
    'Carbonia-Iglesias',
    'Caltanissetta',
    'Cuneo',
    'Como',
    'Cremona',
    'Cosenza',
    'Catania',
    'Catanzaro',
    'Enna',
    'Forlì-Cesena',
    'Ferrara',
    'Foggia',
    'Florence',
    'Fermo',
    'Frosinone',
    'Genoa',
    'Gorizia',
    'Grosseto',
    'Imperia',
    'Isernia',
    'Crotone',
    'Lecco',
    'Lecce',
    'Livorno',
    'Lodi',
    'Latina',
    'Lucca',
    'Monza and Brianza',
    'Macerata',
    'Messina',
    'Milan',
    'Mantua',
    'Modena',
    'Massa and Carrara',
    'Matera',
    'Naples',
    'Novara',
    'Nuoro',
    'Ogliastra',
    'Oristano',
    'Olbia-Tempio',
    'Palermo',
    'Piacenza',
    'Padua',
    'Pescara',
    'Perugia',
    'Pisa',
    'Pordenone',
    'Prato',
    'Parma',
    'Pistoia',
    'Pesaro and Urbino',
    'Pavia',
    'Potenza',
    'Ravenna',
    'Reggio Calabria',
    'Reggio Emilia',
    'Ragusa',
    'Rieti',
    'Rome',
    'Rimini',
    'Rovigo',
    'Salerno',
    'Siena',
    'Sondrio',
    'La Spezia',
    'Syracuse',
    'Sassari',
    'Savona',
    'Taranto',
    'Teramo',
    'Trento',
    'Turin',
    'Trapani',
    'Terni',
    'Trieste',
    'Treviso',
    'Udine',
    'Varese',
    'Verbano-Cusio-Ossola',
    'Vercelli',
    'Venice',
    'Vicenza',
    'Verona',
    'Medio Campidano',
    'Viterbo',
    'Vibo Valentia'
  ],
  japanStates: [
    'Hokkaidō Prefecture',
    'Gunma Prefecture',
    'Saitama Prefecture',
    'Chiba Prefecture',
    'Tokyo',
    'Kanagawa Prefecture',
    'Niigata Prefecture',
    'Toyama Prefecture',
    'Ishikawa Prefecture',
    'Fukui Prefecture',
    'Yamanashi Prefecture',
    'Aomori Prefecture',
    'Nagano Prefecture',
    'Gifu Prefecture',
    'Shizuoka Prefecture',
    'Aichi Prefecture',
    'Mie Prefecture',
    'Shiga Prefecture',
    'Kyōto Prefecture',
    'Ōsaka Prefecture',
    'Hyōgo Prefecture',
    'Nara Prefecture',
    'Iwate Prefecture',
    'Wakayama Prefecture',
    'Tottori Prefecture',
    'Shimane Prefecture',
    'Okayama Prefecture',
    'Hiroshima Prefecture',
    'Yamaguchi Prefecture',
    'Tokushima Prefecture',
    'Kagawa Prefecture',
    'Ehime Prefecture',
    'Kōchi Prefecture',
    'Miyagi Prefecture',
    'Fukuoka Prefecture',
    'Saga Prefecture',
    'Nagasaki Prefecture',
    'Kumamoto Prefecture',
    'Ōita Prefecture',
    'Miyazaki Prefecture',
    'Kagoshima Prefecture',
    'Okinawa Prefecture',
    'Akita Prefecture',
    'Yamagata Prefecture',
    'Fukushima Prefecture',
    'Ibaraki Prefecture',
    'Tochigi Prefecture'
  ],
  koreaStates: [
    'Seoul',
    'Busan',
    'Daegu',
    'Incheon',
    'Gwangju',
    'Daejeon',
    'Ulsan',
    'Gyeonggi Province',
    'Gangwon Province',
    'North Chungcheong Province',
    'South Chungcheong Province',
    'North Jeolla Province',
    'South Jeolla Province',
    'North Gyeongsang Province',
    'South Gyeongsang Province',
    'Jeju',
    'Sejong City'
  ],
  kuwaitStates: [
    'Al Ahmadi Governorate',
    'Al Farwaniyah Governorate',
    'Hawalli Governorate',
    'Al Jahra Governorate',
    'Capital Governorate',
    'Mubarak Al-Kabeer Governorate'
  ],
  latviaStates: ['Riga'],
  lebanonStates: [
    'Akkar Governorate',
    'North Governorate',
    'Beirut Governorate',
    'Baalbek-Hermel Governorate',
    'Beqaa Governorate',
    'South Governorate',
    'Mount Lebanon Governorate',
    'Nabatieh Governorate'
  ],
  malaysiaStates: [
    'Johor',
    'Selangor',
    'Terengganu',
    'Sabah',
    'Sarawak',
    'Kuala Lumpur',
    'Labuan',
    'Putrajaya',
    'Kedah',
    'Kelantan',
    'Malacca',
    'Negeri Sembilan',
    'Pahang',
    'Penang',
    'Perak',
    'Perlis'
  ],
  mexicoStates: [
    'Aguascalientes',
    'Baja California',
    'Baja California Sur',
    'Chihuahua',
    'Colima',
    'Campeche',
    'Coahuila',
    'Chiapas',
    'Federal District',
    'Durango',
    'Guerrero',
    'Guanajuato',
    'Hidalgo',
    'Jalisco',
    'Mexico State',
    'Michoacán',
    'Morelos',
    'Ciudad de México',
    'Nayarit',
    'Nuevo León',
    'Oaxaca',
    'Puebla',
    'Querétaro',
    'Quintana Roo',
    'Sinaloa',
    'San Luis Potosí',
    'Sonora',
    'Tabasco',
    'Tlaxcala',
    'Tamaulipas',
    'Veracruz',
    'Veracruz de Ignacio de la Llave',
    'Yucatán',
    'Zacatecas'
  ],
  moldovaStats: ['Strășeni District'],
  monacoStates: ['La Colle', 'La Condamine', 'Moneghetti'],
  moroccoStates: ['Casablanca', 'Rabat'],
  namibiaStates: ['Khomas Region'],
  netherlandsStates: ['Limburg'],
  newzealandStates: [
    'Auckland Region',
    'Bay of Plenty Region',
    'Canterbury Region',
    'Chatham Islands',
    'Gisborne District',
    "Hawke's Bay Region",
    'Marlborough Region',
    'Manawatu-Wanganui Region',
    'Nelson Region',
    'Northland Region',
    'Otago Region',
    'Southland Region',
    'Tasman District',
    'Taranaki Region',
    'Wellington Region',
    'Waikato Region',
    'West Coast Region'
  ],
  norwayStates: ['Hordaland', 'Sør-Trøndelag', 'Oslo'],
  pakistanStates: ['Sindh'],
  panamaStates: [
    'Bocas del Toro Province',
    'Panamá Oeste Province',
    'Coclé Province',
    'Colón Province',
    'Chiriquí Province',
    'Darién Province',
    'Herrera Province',
    'Los Santos Province',
    'Panamá Province',
    'Veraguas Province',
    'Emberá-Wounaan Comarca',
    'Guna Yala',
    'Ngöbe-Buglé Comarca'
  ],
  peruStates: ['LIMA'],
  philippinesStates: [
    'Ilocos Region',
    'Northern Mindanao',
    'Davao Region',
    'Soccsksargen',
    'Caraga',
    'Autonomous Region in Muslim Mindanao',
    'Cordillera Administrative Region',
    'Cagayan Valley',
    'Central Luzon',
    'Calabarzon',
    'Mimaropa',
    'Bicol Region',
    'Western Visayas',
    'Central Visayas',
    'Eastern Visayas',
    'Zamboanga Peninsula',
    'Abra',
    'Agusan del Norte',
    'Agusan del Sur',
    'Aklan',
    'Albay',
    'Antique',
    'Apayao',
    'Aurora',
    'Bataan',
    'Basilan',
    'Benguet',
    'Biliran',
    'Bohol',
    'Batangas',
    'Batanes',
    'Bukidnon',
    'Bulacan',
    'Cagayan',
    'Camiguin',
    'Camarines Norte',
    'Capiz',
    'Camarines Sur',
    'Catanduanes',
    'Cavite',
    'Cebu',
    'Compostela Valley',
    'Davao Oriental',
    'Davao del Sur',
    'Davao del Norte',
    'Dinagat Islands',
    'Davao Occidental',
    'Eastern Samar',
    'Guimaras',
    'Ifugao',
    'Iloilo',
    'Ilocos Norte',
    'Ilocos Sur',
    'Isabela',
    'Kalinga',
    'Laguna',
    'Lanao del Norte',
    'Lanao del Sur',
    'Leyte',
    'La Union',
    'Marinduque',
    'Maguindanao',
    'Masbate',
    'Occidental Mindoro',
    'Oriental Mindoro',
    'Mountain Province',
    'Misamis Occidental',
    'Misamis Oriental',
    'Cotabato',
    'Metro Manila',
    'Negros Occidental',
    'Negros Oriental',
    'Northern Samar',
    'Nueva Ecija',
    'Nueva Vizcaya',
    'Pampanga',
    'Pangasinan',
    'Palawan',
    'Quezon',
    'Quirino',
    'Rizal',
    'Romblon',
    'Sarangani',
    'South Cotabato',
    'Siquijor',
    'Southern Leyte',
    'Sulu',
    'Sorsogon',
    'Sultan Kudarat',
    'Surigao del Norte',
    'Surigao del Sur',
    'Tarlac',
    'Tawi-Tawi',
    'Zamboanga del Norte',
    'Zamboanga del Sur',
    'Zambales',
    'Zamboanga Sibugay'
  ],
  polandStates: ['Podlaskie Voivodeship'],
  portugalStates: ['Lisbon', 'Porto', 'Coimbra'],
  qatarStates: ['Ad Dawḩah', 'Al Khor'],
  sanmarinoStates: ['Faetano', 'San Marino'],
  saudiarabiaStates: ['Riyadh', 'Makkah'],
  singaporeStates: [
    'Central Singapore Community Development Council',
    'North East Community Development Council',
    'North West Community Development Council',
    'South East Community Development Council',
    'South West Community Development Council'
  ],
  sloveniaStates: ['Sežana Municipality'],
  southafricaStates: [
    'Eastern Cape',
    'Free State',
    'Gauteng',
    'KwaZulu-Natal',
    'Limpopo',
    'Mpumalanga',
    'Northern Cape',
    'North West',
    'Western Cape'
  ],
  spainStates: [
    'Andalusia',
    'Aragon',
    'Asturias',
    'Ávila',
    'Burgos Province',
    'Cantabria',
    'Ceuta',
    'Castile and León',
    'Castilla La Mancha',
    'Canary Islands',
    'Catalonia',
    'Extremadura',
    'Galicia',
    'Léon',
    'Murcia',
    'Madrid',
    'Melilla',
    'Navarra',
    'Palencia Province',
    'Balearic Islands',
    'Basque Country',
    'La Rioja',
    'Salamanca Province',
    'Segovia Province',
    'Soria Province',
    'Valladolid Province',
    'Valencia',
    'Zamora Province'
  ],
  srilankaStates: ['Western Province', 'Colombo District'],
  swedenStates: ['Stockholm County', 'Skåne County'],
  switzerlandStates: [
    'Aargau',
    'Appenzell Innerrhoden',
    'Appenzell Ausserrhoden',
    'Bern',
    'Basel-Land',
    'Basel-Stadt',
    'Fribourg',
    'Geneva',
    'Glarus',
    'Graubünden',
    'Jura',
    'Lucerne',
    'Neuchâtel',
    'Nidwalden',
    'Obwalden',
    'St. Gallen',
    'Schaffhausen',
    'Solothurn',
    'Schwyz',
    'Thurgau',
    'Ticino',
    'Uri',
    'Vaud',
    'Valais',
    'Zug',
    'Zürich'
  ],
  taiwanStates: [
    'Changhua',
    'Chiayi',
    'Hsinchu',
    'Hualien',
    'Yilan',
    'Keelung',
    'Kaohsiung',
    'Kinmen',
    'Lienchiang',
    'Miaoli',
    'Nantou',
    'New Taipei',
    'Penghu',
    'Pingtung',
    'Taoyuan',
    'Tainan',
    'Taipei',
    'Taitung',
    'Taichung',
    'Yunlin'
  ],
  tanzaniaunitedrepublicofStates: ['Arusha', 'Dar es Salaam', 'Shinyanga'],
  unitedrepublicofStates: ['Arusha', 'Dar es Salaam', 'Shinyanga'],
  thailandStates: [
    'Bangkok',
    'Samut Prakan',
    'Nonthaburi',
    'Pathum Thani',
    'Phra Nakhon Si Ayutthaya',
    'Ang Thong',
    'Lop Buri',
    'Sing Buri',
    'Chai Nat',
    'Saraburi',
    'Chon Buri',
    'Rayong',
    'Chanthaburi',
    'Trat',
    'Chachoengsao',
    'Prachin Buri',
    'Nakhon Nayok',
    'Sa Kaeo',
    'Nakhon Ratchasima',
    'Buri Ram',
    'Surin',
    'Si Sa Ket',
    'Ubon Ratchathani',
    'Yasothon',
    'Chaiyaphum',
    'Amnat Charoen',
    'Bueng Kan',
    'Nong Bua Lam Phu',
    'Khon Kaen',
    'Udon Thani',
    'Loei',
    'Nong Khai',
    'Maha Sarakham',
    'Roi Et',
    'Kalasin',
    'Sakon Nakhon',
    'Nakhon Phanom',
    'Mukdahan',
    'Chiang Mai',
    'Lamphun',
    'Lampang',
    'Uttaradit',
    'Phrae',
    'Nan',
    'Phayao',
    'Chiang Rai',
    'Mae Hong Son',
    'Nakhon Sawan',
    'Uthai Thani',
    'Kamphaeng Phet',
    'Tak',
    'Sukhothai',
    'Phitsanulok',
    'Phichit',
    'Phetchabun',
    'Ratchaburi',
    'Kanchanaburi',
    'Suphan Buri',
    'Nakhon Pathom',
    'Samut Sakhon',
    'Samut Songkhram',
    'Phetchaburi',
    'Prachuap Khiri Khan',
    'Nakhon Si Thammarat',
    'Krabi',
    'Phangnga',
    'Phuket',
    'Surat Thani',
    'Ranong',
    'Chumphon',
    'Songkhla',
    'Satun',
    'Trang',
    'Phatthalung',
    'Pattani',
    'Yala',
    'Narathiwat',
    'Pattaya'
  ],
  trinidadandtobagoStates: ['Port of Spain'],
  turkeyStates: [
    'Adana',
    'Balıkesir',
    'Bilecik',
    'Bingöl',
    'Bitlis',
    'Bolu',
    'Burdur',
    'Bursa',
    'Çanakkale',
    'Çankırı',
    'Çorum',
    'Adıyaman',
    'Denizli',
    'Diyarbakır',
    'Edirne',
    'Elazığ',
    'Erzincan',
    'Erzurum',
    'Eskişehir',
    'Gaziantep',
    'Giresun',
    'Gümüşhane',
    'Afyonkarahisar',
    'Hakkâri',
    'Hatay',
    'Isparta',
    'Mersin',
    'Istanbul',
    'İzmir',
    'Kars',
    'Kastamonu',
    'Kayseri',
    'Kırklareli',
    'Ağrı',
    'Kırşehir',
    'Kocaeli',
    'Konya',
    'Kütahya',
    'Malatya',
    'Manisa',
    'Kahramanmaraş',
    'Mardin',
    'Muğla',
    'Muş',
    'Amasya',
    'Nevşehir',
    'Niğde',
    'Ordu',
    'Rize',
    'Sakarya',
    'Samsun',
    'Siirt',
    'Sinop',
    'Sivas',
    'Tekirdağ',
    'Ankara',
    'Tokat',
    'Trabzon',
    'Tunceli',
    'Şanlıurfa',
    'Uşak',
    'Van',
    'Yozgat',
    'Zonguldak',
    'Aksaray',
    'Bayburt',
    'Antalya',
    'Karaman',
    'Kırıkkale',
    'Batman',
    'Şırnak',
    'Bartın',
    'Ardahan',
    'Iğdır',
    'Yalova',
    'Karabük',
    'Kilis',
    'Artvin',
    'Osmaniye',
    'Düzce',
    'Aydın',
    'Fatih'
  ],
  unitedarabemiratesStates: [
    'Ajman Emirate',
    'Abu Dhabi Emirate',
    'Dubai',
    'Fujairah',
    'Ras al-Khaimah',
    'Sharjah Emirate',
    'Umm al-Quwain'
  ],
  unitedkingdomStates: [
    'Armagh, Banbridge and Craigavon',
    'Aberdeenshire',
    'Aberdeen',
    'Argyll and Bute',
    'Ards and North Down',
    'Antrim and Newtownabbey',
    'Angus',
    'Antrim',
    'Ards',
    'Armagh City and District Council',
    'Bath and North East Somerset',
    'Blackburn with Darwen',
    'Bedford',
    'London Borough of Barking and Dagenham',
    'London Borough of Brent',
    'London Borough of Bexley',
    'Belfast district',
    'Bridgend County Borough',
    'Blaenau Gwent County Borough',
    'Birmingham',
    'Buckinghamshire',
    'Ballymena Borough',
    'Ballymoney',
    'Bournemouth',
    'Banbridge',
    'London Borough of Barnet',
    'Brighton and Hove',
    'Barnsley',
    'Bolton',
    'Blackpool',
    'Bracknell Forest',
    'Bradford',
    'London Borough of Bromley',
    'City of Bristol',
    'Bury',
    'Cambridgeshire',
    'Caerphilly County Borough',
    'Central Bedfordshire',
    'Causeway Coast and Glens',
    'Ceredigion',
    'Craigavon Borough Council',
    'Cheshire East',
    'Cheshire West and Chester',
    'Carrickfergus Borough Council',
    'Cookstown District Council',
    'Calderdale',
    'Clackmannanshire',
    'Coleraine Borough Council',
    'Cumbria',
    'London Borough of Camden',
    'Carmarthenshire',
    'Cornwall',
    'Coventry',
    'City and County of Cardiff',
    'London Borough of Croydon',
    'Castlereagh',
    'Conwy County Borough',
    'Darlington',
    'Derbyshire',
    'Denbighshire',
    'City of Derby',
    'Devon',
    'Dungannon and South Tyrone Borough Council',
    'Dumfries and Galloway',
    'Doncaster',
    'Dundee',
    'Dorset',
    'Down District Council',
    'Derry City and Strabane',
    'Derry City Council',
    'Dudley',
    'County Durham',
    'London Borough of Ealing',
    'East Ayrshire',
    'Edinburgh',
    'East Dunbartonshire',
    'East Lothian',
    'Outer Hebrides',
    'London Borough of Enfield',
    'England',
    'East Renfrewshire',
    'East Riding of Yorkshire',
    'Essex',
    'East Sussex',
    'Falkirk',
    'Fermanagh District Council',
    'Fife',
    'Flintshire',
    'Fermanagh and Omagh',
    'Gateshead',
    'Glasgow',
    'Gloucestershire',
    'Royal Borough of Greenwich',
    'Gwynedd',
    'Halton',
    'Hampshire',
    'London Borough of Havering',
    'Herefordshire',
    'London Borough of Hillingdon',
    'Highland',
    'London Borough of Hammersmith and Fulham',
    'London Borough of Hounslow',
    'Hartlepool',
    'Hertfordshire',
    'London Borough of Harrow',
    'London Borough of Haringey',
    'Isles of Scilly',
    'Isle of Wight',
    'London Borough of Islington',
    'Inverclyde',
    'Royal Borough of Kensington and Chelsea',
    'Kent',
    'City of Kingston upon Hull',
    'Kirklees',
    'Royal Borough of Kingston upon Thames',
    'Knowsley',
    'Lancashire',
    'Lisburn and Castlereagh',
    'London Borough of Lambeth',
    'City of Leicester',
    'Leeds',
    'Leicestershire',
    'London Borough of Lewisham',
    'Lincolnshire',
    'Liverpool',
    'Limavady Borough Council',
    'City of London',
    'Larne Borough Council',
    'Lisburn City Council',
    'Manchester',
    'Middlesbrough',
    'Medway',
    'Mid and East Antrim',
    'Magherafelt District Council',
    'Milton Keynes',
    'Midlothian',
    'Monmouthshire',
    'London Borough of Merton',
    'Moray',
    'Merthyr Tydfil County Borough',
    'Mid Ulster',
    'Moyle District Council',
    'North Ayrshire',
    'Northumberland',
    'North Down Borough Council',
    'North East Lincolnshire',
    'Newcastle upon Tyne',
    'Norfolk',
    'City of Nottingham',
    'Northern Ireland',
    'North Lanarkshire',
    'North Lincolnshire',
    'Newry, Mourne and Down',
    'North Somerset',
    'Newtownabbey Borough Council',
    'Northamptonshire',
    'Neath Port Talbot County Borough',
    'Nottinghamshire',
    'North Tyneside',
    'London Borough of Newham',
    'Newport',
    'North Yorkshire',
    'Newry and Mourne District Council',
    'Oldham',
    'Omagh District Council',
    'Orkney Islands',
    'Oxfordshire',
    'Pembrokeshire',
    'Perth and Kinross',
    'City of Plymouth',
    'Poole',
    'City of Portsmouth',
    'Powys',
    'City of Peterborough',
    'Redcar and Cleveland',
    'Rochdale',
    'Rhondda Cynon Taf',
    'London Borough of Redbridge',
    'Reading',
    'Renfrewshire',
    'London Borough of Richmond upon Thames',
    'Rotherham',
    'Rutland',
    'Sandwell',
    'South Ayrshire',
    'Scottish Borders',
    'Scotland',
    'Suffolk',
    'Sefton',
    'South Gloucestershire',
    'Ascension Island',
    'Sheffield',
    'Saint Helena',
    'St Helens',
    'Shropshire',
    'Stockport',
    'Salford',
    'Slough',
    'South Lanarkshire',
    'City of Sunderland',
    'Solihull',
    'Somerset',
    'Southend-on-Sea',
    'Surrey',
    'Strabane District Council',
    'City of Stoke-on-Trent',
    'Stirling',
    'City of Southampton',
    'London Borough of Sutton',
    'Staffordshire',
    'Stockton-on-Tees',
    'South Tyneside',
    'City and County of Swansea',
    'Swindon',
    'London Borough of Southwark',
    'Tameside',
    'Telford and Wrekin',
    'Thurrock',
    'Torbay',
    'Torfaen',
    'Trafford',
    'London Borough of Tower Hamlets',
    'United Kingdom',
    'Vale of Glamorgan',
    'Warwickshire',
    'West Berkshire',
    'West Dunbartonshire',
    'London Borough of Waltham Forest',
    'Metropolitan Borough of Wigan',
    'Wiltshire',
    'Wakefield',
    'Walsall',
    'West Lothian',
    'Wales',
    'City of Wolverhampton',
    'West Midlands',
    'London Borough of Wandsworth',
    'Windsor and Maidenhead',
    'Wokingham',
    'Worcestershire',
    'Wirral',
    'Warrington',
    'Wrexham County Borough',
    'City of Westminster',
    'West Sussex',
    'City of York',
    'Shetland Islands'
  ],
  unitedstatesStates: [
    'Armed Forces Americas',
    'Armed Forces Europe',
    'Alaska',
    'Alabama',
    'Armed Forces Pacific',
    'Arkansas',
    'American Samoa',
    'Arizona',
    'California',
    'Colorado',
    'Connecticut',
    'District of Columbia',
    'Delaware',
    'Florida',
    'Federated Micronesia',
    'Georgia',
    'Guam',
    'Hawaii',
    'Iowa',
    'Idaho',
    'Illinois',
    'Indiana',
    'Kansas',
    'Kentucky',
    'Louisiana',
    'Massachusetts',
    'Maryland',
    'Maine',
    'Marshall Islands',
    'Michigan',
    'Minnesota',
    'Missouri',
    'Northern Mariana Islands',
    'Mississippi',
    'Montana',
    'North Carolina',
    'North Dakota',
    'Nebraska',
    'New Hampshire',
    'New Jersey',
    'New Mexico',
    'Nevada',
    'New York',
    'Ohio',
    'Oklahoma',
    'Oregon',
    'Pennsylvania',
    'Puerto Rico',
    'Palau',
    'Rhode Island',
    'South Carolina',
    'South Dakota',
    'Tennessee',
    'Texas',
    'United States Minor Outlying Islands',
    'Utah',
    'Virginia',
    'US Virgin Islands',
    'Vermont',
    'Washington',
    'Wisconsin',
    'West Virginia',
    'Wyoming'
  ]
};

export const locations = union(rawLocations.unitedstatesStates)(rawLocations.countries);

export const countries = rawLocations.countries.filter(item => item !== 'New York');

export const states = rawLocations.unitedstatesStates;

export const getStateArrayByCountry = countryName => {
  if (countryName === 'Tanzania, United Republic of') {
    return rawLocations.tanzaniaunitedrepublicofStates;
  }
  if (countryName === 'Congo, the Democratic Republic of the') {
    return rawLocations.congothedemocraticrepublicoftheStates;
  }
  if (countryName === 'Korea, Republic of') {
    return rawLocations.koreaStates;
  }
  if (countryName === 'Moldova, Republic of') {
    return rawLocations.moldovaStats;
  }

  const formattedCountryName = `${countryName.toLowerCase().replace(/\s+/g, '')}States`;
  // Check if the state array for the given country exists
  if (Object.prototype.hasOwnProperty.call(rawLocations, formattedCountryName)) {
    return rawLocations[formattedCountryName];
  } else {
    return []; // Return an empty array if the country is not found
  }
};
